import isEmpty from 'lodash/isEmpty'
import React from 'react'
import { AddNewConversationButton } from './AddNewConversationButton'
import { EmptyContent } from './EmptyContent'
import { routesDef } from '../../../../config/routes'
import { DataSuspense, HorizontalStack } from '@ztechapps/webui.util'
import { Table } from '@ztechapps/webui.data-tools'
import { Row } from '@ztechapps/webui.data-tools'
import { useHistory } from '@ztechapps/common.hook'
import { truncate } from '@ztechapps/common.utils'
import { LocalDateTime } from '@ztechapps/webui.date'
import { useMessageListContext } from './Context'

export const ConversationList = () => {
  const { chatListResult } = useMessageListContext()
  const { list, loading, error } = chatListResult

  return (
    <DataSuspense loading={loading} error={error} isEmpty={isEmpty(list)} emptyComponent={<EmptyContent />}>
      <HorizontalStack className="justify-content-end mb-3">
        <AddNewConversationButton />
      </HorizontalStack>
      <Table dataArray={list} row={ListRow} />
    </DataSuspense>
  )
}

const ListRow = (props) => {
  const { externalId, subject, lastMessageAt } = props
  const history = useHistory()
  const onClick = (e) => {
    e.preventDefault()
    history.push(routesDef.AccountMessageDetails.altPath({ _id: externalId }))
  }
  return (
    <Row {...props}>
      <td>
        <a href="/" onClick={onClick}>
          {truncate(subject, 100)}
        </a>
      </td>
      <td style={{ width: '30%' }}>
        <LocalDateTime value={lastMessageAt} />
      </td>
    </Row>
  )
}
